<section id="intro" class="landing-intro flex min-h-screen flex-col items-center justify-center overflow-hidden bg-surface-950 text-white">
    <app-landing-starfield [particles]="particles()" [stars]="stars()" />

    <div class="landing-intro-glow absolute inset-0"></div>

    <div class="relative flex flex-col items-center gap-4 px-4 text-center">
        <div class="landing-intro-brand-row grid justify-items-center gap-2">
            <span class="landing-intro-brand text-xl font-semibold uppercase tracking-[0.5em] text-white/80 sm:text-2xl">{{ text().introBrand }}</span>
            <span class="landing-intro-divider" aria-hidden="true"></span>
        </div>
        <span class="landing-intro-presents text-xs font-semibold uppercase tracking-[0.5em] text-white/60 sm:text-sm">{{ text().introPresentsWord }}</span>
        <h1 class="landing-intro-title text-6xl font-extrabold tracking-tight sm:text-8xl lg:text-9xl">MoveNow</h1>
    </div>

    <div class="landing-intro-hint absolute bottom-16 flex flex-col items-center gap-2 text-white/60">
        <span class="text-xs font-medium uppercase tracking-[0.3em]">{{ text().introScrollHint }}</span>
        <i class="pi pi-chevron-down landing-intro-chevron"></i>
    </div>
</section>
